import type { ReactNode } from 'react';

export interface ChipProps {
  label: string;
  selected?: boolean;
  avatar?: ReactNode;
  onToggle?: () => void;
  className?: string;
  variant?: 'primary' | 'neutral';
}

const selectedStyles: Record<string, string> = {
  primary: 'bg-primary text-primary-foreground border-primary',
  neutral: 'bg-border text-foreground border-border',
};

export function Chip({
  label,
  selected = false,
  avatar,
  onToggle,
  className = '',
  variant = 'primary',
}: ChipProps) {
  return (
    <button
      type="button"
      role="option"
      aria-selected={selected}
      onClick={onToggle}
      className={[
        'inline-flex items-center gap-2 shrink-0 rounded-full border px-3 py-1.5 text-sm font-normal whitespace-nowrap cursor-pointer',
        'transition-colors duration-150',
        'focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary',
        selected
          ? selectedStyles[variant]
          : 'bg-background text-foreground border-border hover:bg-muted',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
    >
      {avatar && (
        <span className="inline-flex shrink-0 text-xl leading-none">
          {avatar}
        </span>
      )}
      {label}
    </button>
  );
}
